import { createRoot } from 'react-dom/client';
import { useState, useEffect } from 'react';
import App from './App.tsx';
import './index.css';
import AnimatedLogoLoader from './components/AnimatedLogoLoader';

// RootComponent with loading state handling
const RootComponent = () => {
  // Track initial loading state
  const [loading, setLoading] = useState(true);

  // Handle initial page load
  useEffect(() => {
    // If document is already complete, short-circuit
    if (document.readyState === 'complete') {
      setLoading(false);
      return;
    }

    // Wait for document to be fully loaded
    const handleLoad = () => {
      // Use a short delay to ensure all resources are loaded
      // and avoid flickering as components mount
      setTimeout(() => {
        setLoading(false);
      }, 100);
    };

    window.addEventListener('load', handleLoad);
    return () => window.removeEventListener('load', handleLoad);
  }, []);

  return (
    <>
      <AnimatedLogoLoader 
        isLoading={loading} 
        minDisplayTime={800} 
      />
      <App />
    </>
  );
};

createRoot(document.getElementById("root")!).render(<RootComponent />);
